(() => {
  'use strict';
  const mounted = new WeakSet();
  const starPath = 'm12 3 2.8 5.7 6.3.9-4.5 4.4 1.1 6.2-5.7-3-5.7 3 1.1-6.2L3.2 9.6l6.3-.9Z';
  function mount(scope = document) {
    const roots = scope.matches?.('[data-kinora-reviews]') ? [scope] : scope.querySelectorAll('[data-kinora-reviews]');
    roots.forEach(root => {
      if (mounted.has(root)) return;
      mounted.add(root);
      const grid = root.querySelector('[data-review-grid]');
      const status = root.querySelector('[data-review-status]');
      const more = root.querySelector('[data-review-more]');
      const photoTemplates=[...root.querySelectorAll('[data-review-photo-template]')];
      const dialog = root.querySelector('[data-review-dialog]');
      const enlarged = root.querySelector('[data-review-enlarged]');
      let records = null;
      let loading = false;
      let visible = 6;
      let photoTrigger = null;
      function node(tag, className, text) {
        const el = document.createElement(tag);
        if (className) el.className = className;
        if (text !== undefined) el.textContent = text;
        return el;
      }
      function card(record) {
        const article = node('article', 'kn-review');
        article.dataset.reviewId = String(record.id);
        const header = node('header');
        header.append(node('span', 'kn-review__author', `${record.name} · ${record.country}`));
        const stars = node('span', 'kn-review__stars');
        stars.setAttribute('aria-label', `${record.rating} out of 5 stars`);
        for (let i = 0; i < 5; i++) {
          const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
          svg.setAttribute('viewBox', '0 0 24 24');
          svg.setAttribute('aria-hidden', 'true');
          const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
          path.setAttribute('d', starPath);
          path.setAttribute('fill', i < record.rating ? 'currentColor' : 'none');
          path.setAttribute('stroke', 'currentColor');
          path.setAttribute('stroke-width', '1.3');
          svg.append(path);
          stars.append(svg);
        }
        header.append(stars);
        const brandText = text => text.replace(/\bKinora(?!™)\b/g, 'Kinora™');
        article.append(header, node('h3', '', brandText(record.title)), node('p', 'kn-review__body', brandText(record.body)));
        photoTemplates.filter(template=>Number(template.dataset.photoReviewId)===record.id).forEach(template=>article.append(template.content.cloneNode(true)));
        return article;
      }
      function render() {
        const count=Math.min(visible,records.length);
        const fragment=document.createDocumentFragment();
        records.slice(0,count).forEach((record,index)=>{
          fragment.append(card(record));
        });
        grid.replaceChildren(fragment);
        status.textContent='';
        more.hidden=count>=records.length;
        more.disabled=false;
        more.textContent='See more';
      }
      async function load() {
        if (records || loading) return;
        loading = true;
        more.disabled = true;
        more.textContent = 'Loading reviews…';
        root.setAttribute('aria-busy', 'true');
        try {
          const response = await fetch(root.dataset.reviewsUrl, { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
          if (!response.ok) throw new Error('Review request failed');
          const data = await response.json();
          if (!Array.isArray(data) || !data.every(record => Number.isInteger(record.id) && Number.isInteger(record.rating) && record.rating >= 1 && record.rating <= 5 && ['US', 'CA'].includes(record.country) && ['name', 'title', 'body'].every(key => typeof record[key] === 'string'))) throw new Error('Invalid review data');
          records = data;
          render();
        } catch (_) {
          status.textContent = 'More reviews could not load. Please try again.';
          more.disabled = false;
          more.textContent = 'See more';
        } finally {
          loading = false;
          root.removeAttribute('aria-busy');
        }
      }
      more.addEventListener('click',async()=>{
        visible+=6;
        if(records)render();
        else {await load();if(!records)visible-=6;}
      });
      root.addEventListener('click',event=>{
        const link=event.target.closest('[data-review-photo]');
        if(!link || !dialog?.showModal)return;
        event.preventDefault();
        photoTrigger=link;
        enlarged.src=link.href;
        enlarged.alt=link.querySelector('img')?.alt || 'Customer photo';
        dialog.showModal();
      });
      root.querySelector('[data-review-close]')?.addEventListener('click', () => dialog.close());
      dialog?.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
      dialog?.addEventListener('close', () => photoTrigger?.focus({ preventScroll: true }));
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) { observer.disconnect(); load(); }
        }, { rootMargin: '600px 0px' });
        observer.observe(root);
      } else load();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(), { once: true }); else mount();
  document.addEventListener('shopify:section:load', event => mount(event.target));
})();
